import { REGISTER_API_URL } from "../../config/constants";

export { REGISTER_API_URL };

export const SECURITY_QUESTIONS_PLACEHOLDER = "No questions available";

function decodeJwtPayload(token) {
  const parts = token.split(".");
  if (parts.length < 2) return null;

  try {
    const base64 = parts[1].replaceAll("-", "+").replaceAll("_", "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    const payload = atob(padded);
    return JSON.parse(payload);
  } catch {
    return null;
  }
}

export function getRoleFromToken(token) {
  const payload = decodeJwtPayload(token);
  if (!payload) return "User";

  const roleClaim = payload.role;
  if (typeof roleClaim === "string" && roleClaim.trim()) {
    return roleClaim;
  }

  const rolesClaim = payload.roles;
  if (Array.isArray(rolesClaim) && rolesClaim.length > 0) {
    const firstRole = rolesClaim[0];
    if (typeof firstRole === "string" && firstRole.trim()) {
      return firstRole;
    }
  }

  const authoritiesClaim = payload.authorities;
  if (Array.isArray(authoritiesClaim) && authoritiesClaim.length > 0) {
    const firstAuthority = authoritiesClaim[0];
    if (typeof firstAuthority === "string" && firstAuthority.trim()) {
      return firstAuthority;
    }
  }

  return "User";
}

export function normalizeRegisterToken(token) {
  return token.replace(/^"|"$/g, "").replace(/^Bearer\s+/i, "").trim();
}

export function getTokenType() {
  return sessionStorage.getItem("tokenType") || "Bearer";
}
